<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Contracts') }}
    </template>
    <template #header-actions>
      <WdsStack class="tw-mb-2" direction-row gap-md align-center>
        <WdsStack class="new-experience" gap-sm align-center justify-center>
          <WdsToggle
            :checked="selectedTable === 'hires'"
            primary
            data-test="new-experience"
            @update:checked="selectedTable = $event ? 'hires' : 'contracts'"
          />
          <WdsText>{{ $t('New experience') }}</WdsText>
          <WdsLabel sm warning subtle>
            Beta
            <WdsIcon
              :size="13"
              weight="thin"
              :name="WdsIconNameEnum.LIGHT"
              class="!tw-inline-block"
            />
          </WdsLabel>
        </WdsStack>

        <WdsButton href="/hire" primary>
          <WdsStack gap-sm align-center justify-center>
            <WdsIcon :name="WdsIconNameEnum.PLUS" />
            {{ $t('Hire') }}
          </WdsStack>
        </WdsButton>
      </WdsStack>
    </template>
  </PageHeader>

  <HiresGraphqlTable v-if="selectedTable === 'hires'" />
  <TableContracts v-else />
</template>

<script lang="ts" setup>
import {
  WdsButton,
  WdsIcon,
  WdsIconNameEnum,
  WdsLabel,
  WdsStack,
  WdsText,
  WdsToggle,
} from '@worksome/wds-components'
import PageHeader from '@/components/PageHeader.vue'
import { $t } from '@/composables/translation'
import HiresGraphqlTable from '@/components/Hire/HiresGraphqlTable.vue'
import TableContracts from '@/components/TableContracts.vue'
import useLocalStorageEncoder from '@/composables/useLocalStorageEncoder'

const selectedTable = useLocalStorageEncoder('table', 'contracts', (raw, _) =>
  raw === '' ? 'contracts' : raw,
)
</script>

<style lang="scss" scoped>
:deep(.wds-toggle-wrapper .toggle-cursor-pointer input) {
  display: contents;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  70% {
    background-position: 50% 50%; /* Moves slowly for most of the time */
  }
  85% {
    background-position: 150% 50%; /* Fast swoosh happens here */
  }
  100% {
    background-position: 200% 50%; /* Ends the cycle smoothly */
  }
}

.new-experience {
  position: relative;
  padding: 8px;
  border-radius: 40px; /* Rounded corners */
  background: linear-gradient(
    90deg,
    #c3b6f9,
    #ffc89e,
    #c3b6f9
  ); /* Repeat colors for seamless effect */
  background-size: 200% 200%; /* Larger gradient area for smooth animation */
  animation: gradient-animation 5s ease-in-out 4; /* Animation runs 4 times */
  animation-fill-mode: forwards; /* Keeps the final state of the animation */
}

.new-experience::before {
  content: '';
  position: absolute;
  top: 2px; /* Border thickness */
  left: 2px;
  right: 2px;
  bottom: 2px;
  border-radius: 38px; /* Match the parent border-radius minus border thickness */
  background: white; /* Fill the content area with the background color */
  z-index: 1;
}

.new-experience > * {
  position: relative;
  z-index: 2; /* Ensure content stays on top */
}
</style>
